import { useQuery } from '@tanstack/react-query';
import { getSprint } from '../api/sprint-api/sprint-api';

export const useProjectSprints = (projectId?: string | number) => {
  const query = useQuery({
    queryKey: ['sprints', projectId],
    queryFn: async () => {
      const result = await getSprint();
      if (!result) return [];
      if (Array.isArray(result)) return result;
      return [result];
    },
    enabled: !!projectId,
    staleTime: 5 * 60 * 1000, // 5 minutes - data is fresh for 5 minutes
    refetchOnMount: true, // Don't refetch on mount if data is fresh
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });

  return {
    sprints: query.data || [],
    isLoading: query.isLoading,
    error: query.error,
  };
};
